<template>
    <table class="table table-striped additions-table">
        <thead>
        <tr>
            <th colspan="3">{{trans.attendance.deposits}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th>
                <input
                        type="text"
                        class="form-control"
                        :placeholder="trans.attendance.note"
                        v-model="newDepositTitle"
                        :disabled="newDepositLoading"
                        :class="{'loading disabled': newDepositLoading }"
                />
            </th>
            <td style="width: 40%;">
                <div class="input-group">
                    <input
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="newDepositAmount"
                            :disabled="newDepositLoading"
                            :class="{'loading disabled': newDepositLoading }"
                    >
                    <div class="input-group-append">
                                    <span class="input-group-text">
                                        {{ restaurantCurrency }}
                                    </span>
                    </div>
                </div>
            </td>
            <td style="width: 10%;">
                <button
                        type="button"
                        class="btn btn-success btn-square-loading-save"
                        :class="{'loading disabled': newDepositLoading }"
                        @click="addDeposit"
                >
                    <i class="fal fa-save"></i><i class="loadingSpinner"></i>
                </button>
            </td>
        </tr>
        <tr v-for="deposit in deposits">
            <td>{{ deposit.title }}</td>
            <td class="text-right"><span>{{ parseFloat(deposit.amount).toFixed(2) }}&nbsp;{{ restaurantCurrency }}</span></td>
            <td class="text-right" style="white-space: nowrap;">
                <button class="btn btn-link p-0" @click="deleteDeposit(deposit.id)" :disabled="depositsLoading.some(id => id === deposit.id)">
                    <i class="fas fa-spinner text-danger" v-if="depositsLoading.some(id => id === deposit.id)"></i>
                    <i class="fal fa-fw fa-trash-alt text-danger" v-else></i>
                </button>
            </td>
        </tr>
        <tr>
            <td style="width: 50%"><b>{{ trans.attendance.deposits_together }}:</b></td>
            <td class="text-right"><b>{{ depositsSum.toFixed(2) }}&nbsp;{{ restaurantCurrency }}</b></td>
            <td></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: 'deposits',
        data: function() {
            return {
                newDepositLoading: false,
                depositsLoading: [],
                newDepositAmount: 0,
                newDepositTitle: '',
            }
        },

        props: {
            'deposits': {
                type: Array
            },
            'depositsSum': {
                type: Number
            },
            'trans': {
                type: Object
            },
            'restaurantCurrency': {
                type: String
            },
            'depositUrlStore': {
                type: String
            },
            'depositUrlDestroy': {
                type: String
            },
        },

        created() {
        },

        methods: {
            addDeposit()  {
                this.newDepositLoading = true;
                const data = {
                    amount: this.newDepositAmount,
                    title: this.newDepositTitle
                };
                
                axios.post(this.depositUrlStore, data).then(response => {
                    this.newDepositLoading = false;
                    this.refreshAttendance();
                    this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                    this.newDepositAmount = 0;
                    this.newDepositTitle = '';
                }).catch(error => {
                    this.newDepositLoading = false;
                    this.refreshAttendance();
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                })
            },
            deleteDeposit(depositId) {
                this.depositsLoading.push(depositId);
                // TODO: correct URL once API is finished
                axios.post(this.depositUrlDestroy.replace("%ID%",depositId)).then(response => {
                    this.depositsLoading = this.depositsLoading.filter(id => id !== depositId);
                    this.refreshAttendance();
                    this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                }, error => {
                    this.depositsLoading = this.depositsLoading.filter(id => id !== depositId);
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                })
            },
            refreshAttendance(withLoading = true) {
                this.$parent.$emit('refreshattendance', withLoading);
            }
        },
        computed: {
            totalDeposit() {
                return this.deposits.reduce((total, deposit) => {
                    return total + deposit.amount;
                }, 0)
            }
        }
    }
</script>


<style lang="scss" scoped>
    .btn-square-loading-save,
    .btn.loading.btn-square-loading-save {
        width: 38px;
        height: 35px;
        padding-right: 0.75rem !important;
        text-align: center;

        .loadingSpinner {
            margin-left: -10px;
            left: auto;
            right: auto;
        }
    }
    .form-control {
        padding-right: 12px !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/Deposits.vue